import React from 'react';

import Layout from '../components/blocks/Layout';
import SEO from '../components/blocks/SEO';
import CaseStudiesHeader from '../components/slides/new-case-studies/CaseStudiesHeader';
import CaseStudiesContent from '../components/slides/new-case-studies/CaseStudiesContent';
import CaseStudiesFeedbacks from '../components/slides/new-case-studies/Feedbacks';

const CaseStudies = () => {
  return (
    <Layout>
      <SEO
        title="Case Studies | Deadline Funnel"
        description="Course creators, marketers, and business owners are using Deadline Funnel every day to grow their impact through real evergreen marketing. Are you next?"
      />
      <CaseStudiesHeader />
      <CaseStudiesContent />
      <CaseStudiesFeedbacks />
    </Layout>
  )
};

export default CaseStudies;